/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_1_Item_3_TitleInputs */

const en_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest Best Teachers in State`)
};

const es_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejores profesores del estado según Golf Digest`)
};

const de_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest: Beste Golflehrer im Bundesstaat`)
};

const zh_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest 州内最佳教师`)
};

const ar_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أفضل المدربين في الولاية حسب Golf Digest`)
};

const fr_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleurs enseignants de l’État selon Golf Digest`)
};

const vi_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Những giáo viên tốt nhất tiểu bang theo Golf Digest`)
};

const sw_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walimu Bora katika Jimbo kwa mujibu wa Golf Digest`)
};

const th_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ครูที่ดีที่สุดในรัฐจาก Golf Digest`)
};

const bs_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najbolji učitelji u saveznoj državi prema Golf Digestu`)
};

const ja_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest選出 州内ベスト指導者`)
};

const ko_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest 선정 주 최고의 교사`)
};

const pt_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhores Professores do Estado segundo a Golf Digest`)
};

const it_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tra i migliori insegnanti dello Stato secondo Golf Digest`)
};

const sv_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest: bästa lärarna i delstaten`)
};

const nl_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest: beste golfleraren van de staat`)
};

const da_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest: bedste trænere i delstaten`)
};

const nb_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digests beste lærere i delstaten`)
};

const fi_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digestin osavaltion parhaat opettajat`)
};

const pl_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepsi nauczyciele w stanie według Golf Digest`)
};

const ru_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лучшие преподаватели штата по версии Golf Digest`)
};

const tr_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest'e göre eyaletin en iyi öğretmenleri`)
};

const hi_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest के अनुसार राज्य के सर्वश्रेष्ठ शिक्षक`)
};

const id_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guru Terbaik di Negara Bagian versi Golf Digest`)
};

const ms_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guru Terbaik Negeri versi Golf Digest`)
};

const cs_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest: Nejlepší učitelé ve státě`)
};

const el_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Οι καλύτεροι δάσκαλοι της πολιτείας κατά το Golf Digest`)
};

const he_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`המורים הטובים ביותר במדינה לפי Golf Digest`)
};

const af_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golf Digest se beste onderwysers in die staat`)
};

const hu_about_content_honor_1_item_3_title = /** @type {(inputs: About_Content_Honor_1_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Golf Digest szerint az állam legjobb oktatói`)
};

/**
* | output |
* | --- |
* | "Golf Digest Best Teachers in State" |
*
* @param {About_Content_Honor_1_Item_3_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_1_item_3_title = /** @type {((inputs?: About_Content_Honor_1_Item_3_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_1_Item_3_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_1_item_3_title(inputs)
	if (locale === "de") return de_about_content_honor_1_item_3_title(inputs)
	if (locale === "zh") return zh_about_content_honor_1_item_3_title(inputs)
	if (locale === "ar") return ar_about_content_honor_1_item_3_title(inputs)
	if (locale === "fr") return fr_about_content_honor_1_item_3_title(inputs)
	if (locale === "vi") return vi_about_content_honor_1_item_3_title(inputs)
	if (locale === "sw") return sw_about_content_honor_1_item_3_title(inputs)
	if (locale === "th") return th_about_content_honor_1_item_3_title(inputs)
	if (locale === "bs") return bs_about_content_honor_1_item_3_title(inputs)
	if (locale === "ja") return ja_about_content_honor_1_item_3_title(inputs)
	if (locale === "ko") return ko_about_content_honor_1_item_3_title(inputs)
	if (locale === "pt") return pt_about_content_honor_1_item_3_title(inputs)
	if (locale === "it") return it_about_content_honor_1_item_3_title(inputs)
	if (locale === "sv") return sv_about_content_honor_1_item_3_title(inputs)
	if (locale === "nl") return nl_about_content_honor_1_item_3_title(inputs)
	if (locale === "da") return da_about_content_honor_1_item_3_title(inputs)
	if (locale === "nb") return nb_about_content_honor_1_item_3_title(inputs)
	if (locale === "fi") return fi_about_content_honor_1_item_3_title(inputs)
	if (locale === "pl") return pl_about_content_honor_1_item_3_title(inputs)
	if (locale === "ru") return ru_about_content_honor_1_item_3_title(inputs)
	if (locale === "tr") return tr_about_content_honor_1_item_3_title(inputs)
	if (locale === "hi") return hi_about_content_honor_1_item_3_title(inputs)
	if (locale === "id") return id_about_content_honor_1_item_3_title(inputs)
	if (locale === "ms") return ms_about_content_honor_1_item_3_title(inputs)
	if (locale === "cs") return cs_about_content_honor_1_item_3_title(inputs)
	if (locale === "el") return el_about_content_honor_1_item_3_title(inputs)
	if (locale === "he") return he_about_content_honor_1_item_3_title(inputs)
	if (locale === "af") return af_about_content_honor_1_item_3_title(inputs)
	if (locale === "hu") return hu_about_content_honor_1_item_3_title(inputs)
	return en_about_content_honor_1_item_3_title(inputs)
});